import { render } from "./KRPlacardList.vue?vue&type=template&id=1abb03c2&scoped=true"
import script from "./KRPlacardList.vue?vue&type=script&lang=js"
export * from "./KRPlacardList.vue?vue&type=script&lang=js"

import "./KRPlacardList.vue?vue&type=style&index=0&id=1abb03c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1abb03c2"

export default script